import React from "react";
import { useTranslation } from "react-i18next";

const Step2 = (props) => {
  const { t } = useTranslation();
  const status = props.status;

  return (
    <div>
      {status.success ? (
        <p>
          {t("feedback1")} <br />
          {t("feedback2")} <br />
          <a
            href={`${window.location.origin}${window.location.pathname}?guid=${props.guid}&tcode=${props.tcode}`}
          >
             {t("feedback3")}
          </a>
        </p>
      ) : status.error ? (
        <p>{status.error}</p>
      ) : null}
    </div>
  );
};

export default Step2;
